import { cardNode } from "../fragments/cardNode";

export function author(sourceId, page) {
    const authorInfo = `
                title
                name
                biography
                sourceId
                url
                links {
                  type
                  title
                  url
                }
                photo {
                  aspects {
                    ratio1x1 {
                      url
                    }
                  }
                }`;

    return `
        query {
            author(sourceId: "${sourceId}") {
                ${page === 1 ? authorInfo : ""}
                recentContent(page: ${page}, sortDate: "publishedAt") {
                  nodes {
                    ...cardNode
                  }
                }
            }
        }
        ${cardNode}
    `;
}
